var bannerSwiper = [];
export default ({
    name : 'Category'
    , props : {
        'textColorStyle' : Object // common_header computed value.
    }
    , data () {
        return {
            categoryList : []
        }
    }
    , created () {
        this.code = 'hamburger_menu';
        this.basic = this.getDetailDataByCode(this.code);
        if (this.basic.use == 'Y' && this.basic.data.category_use.value == 'Y') {
            this.getCategoryList();
        }
        return {}
    }
    , mounted () {
        if (this.basic.use == 'N' || this.basic.data.category_use.value == 'N') { 
            this.execCategoryUseNoInit()
        } else {
            this.execCategoryUseYesInit()
        }
    }
    , computed : {
        isUseCategory : function () {
            if (this.basic.use == 'N') { 
                this.execCategoryUseNoInit()
                return false
            }
            if (this.basic.data.category_use.value == 'N') { 
                this.execCategoryUseNoInit()
                return false
            }
            this.execCategoryUseYesInit()
            return true;
        }
        , isShowCategory : function () {
            if (this.categoryList.length > 0) return true
            return false
        }
    }
    , methods : {
        getCategoryList () {
            let params = new FormData()
			this.$http.post(`${this.baseURI}/plan/getCategoryDisplayList`, params, { headers : this.axiosCommonHeader }
            ).then(response => {
                if (response.data.length == 0) {
                    return
                }
                this.setCategoryList(response.data)
            }).catch(error => {
            })
        }
        , setCategoryList (data) {
            if (data.list.length == 0) {
                this.execCategoryListEmptyState()
                return
            }
            this.categoryList = data.list;
        }
        , execCategoryUseYesInit () {
            if (templateType == 'simple') {
                if (document.querySelector('#header .base')) {
                    let base = document.querySelector('#header .base')
                    //base.style.paddingBottom = '38px'
                    base.classList.add('use-category')
                }
                if (document.querySelector('body .wrap')) {
                    let wrap = document.querySelector('body .wrap')
                    let event;
                    if (typeof Event == 'function') {
                        event = new Event('resize')
                    } else {
                        event = document.createEvent('Event')
                        event.initEvent('resize', true, true)
                    }
                    wrap.dispatchEvent(event)
                }
            }
        }
        , execCategoryUseNoInit () {
            if (templateType == 'simple') {
                this.deleteBannerSwipe()
                if (document.querySelector('#header .base')) {
                    let base = document.querySelector('#header .base')
                    //base.style.paddingBottom = '0px'
                    base.classList.remove('use-category')
                }
                if (document.querySelector('body .wrap')) {
                    let wrap = document.querySelector('body .wrap')
                    let event;
                    if (typeof Event == 'function') {
                        event = new Event('resize')
                    } else {
                        event = document.createEvent('Event')
                        event.initEvent('resize', true, true)
                    }
                    wrap.dispatchEvent(event)
                }
            }
        }
        , categorySwiperShop () {
            let categorylastBtn = '<a href="javascript:void(0)" class="lastBtn">최하단</a>'
            $m('.cSwiperNewWrap').append(categorylastBtn);

            // 23.03.15 이현진 상단 하위분류 메뉴 스와이퍼 추가
            var mSwiperW = $m('.cSwiperNew').width();
            var mWinW = $m('.cSwiperNewWrap').width() - 26;
            if (mSwiperW < mWinW) {
                
            } else {
                var swiper = new Swiper('.cSwiperNewWrap.swiper-container', {
                    slidesPerView: 'auto',
                    autoHeight: true,
                });
                
                $m('.cSwiperNewWrap .lastBtn').on('click', function(){
                    swiper.slideTo(swiper.slides.length, 1000);
                });

                $m('.cSwiperNew').css('display','flex');
                
                if ($m('.cSwiperNew').css('display') == 'flex') {
                    $m('.cSwiperNewWrap .lastBtn').show();
                }
            }
        }
        , categorySwiper () {
            this.deleteBannerSwipe()
            let categoryListElement = $m('#header .js-in-header-category')
            let categorylastBtn = '<a href="javascript:void(0)" class="lastBtn">최하단</a>'
            if (typeof categoryListElement == 'undefined' || categoryListElement.length == 0) {
                baseNoneBgPostionFixedCheck()
                return
            }
            let categoryListHtml = categoryListElement.html();
            let hdBgCate = $m('#header .js-hdBg-category')
            let baseCate = $m('#header .js-base-category')
            hdBgCate.html(categoryListHtml).addClass('on');
            baseCate.html(categoryListHtml).addClass('on').show();
            baseCate.append(categorylastBtn);
            let option = {
                //speed : 400,
                //width: 'auto',
                freeMode: true
                , slidesPerView: 'auto'
			}
			bannerSwiper[0] = new Swiper('#header .js-hdBg-category', option);
            baseNoneBgPostionFixedCheck()

            var swiperW = $m('.js-base-category .swiper-wrapper').width();
            var winW = $m('.js-base-category').width() - 26;

            if (swiperW < winW) {

            } else {
                var swiper = new Swiper('.js-base-category', {
                    slidesPerView: 'auto',
                    autoHeight: true,
                });
                
                $m('.js-base-category .lastBtn').on('click', function(){
                    swiper.slideTo(swiper.slides.length, 1000);
                });

                $m('.js-base-category .swiper-wrapper').css('display','flex');
                
                if($m('.js-base-category .swiper-wrapper').css('display') == 'flex') {
                    $m('.js-base-category .lastBtn').show();
                }
            }
		}
        , deleteBannerSwipe () {
            let hdBgCate = $m('#header .js-hdBg-category')
            let baseCate = $m('#header .js-base-category')
            if (hdBgCate) {
                $m('ul', hdBgCate).remove();
                hdBgCate.removeClass('on').hide();
            }
            if (baseCate) {
                $m('ul', baseCate).remove();
                baseCate.removeClass('on').hide();
            }
            for (var i in bannerSwiper) {
                if (bannerSwiper[i]) { delete bannerSwiper[i] }
            }
        }
        , execCategoryListEmptyState () {
            if (this.categoryList.length > 0) { // ex> 3 > 0 으로 저장.
                this.categoryList = [] 
            }
            if (templateType == 'simple') {
                this.categorySwiper()
            }
        }
        , checkCategoryDisplayChange () {
            let category        = this.basic.data.category_display.value
            let categoryIds     = []
            for (var i in category) {
                if ("ppc_id" in category[i] && category[i].ppc_menu_display == 'Y') {
                    categoryIds.push(category[i].ppc_id);
                }
            }
            if (categoryIds.length < 1) { 
                this.execCategoryListEmptyState()
                return false 
            }
            if (this.categoryList.length < 1 && categoryIds.length > 0) { return true }
            if (this.categoryList.length > categoryIds.length         ) { return true }

            let isMore = false
            let nowCategoryList = this.categoryList
            let categoryListIds = []
            for (var j in nowCategoryList) {
                if ("ppc_id" in nowCategoryList[j] && nowCategoryList[j].ppc_menu_display == 'Y') {
                    categoryListIds.push(nowCategoryList[j].ppc_id)
                }
            }
            for (var k in categoryIds) {
                if (categoryListIds.includes(categoryIds[k]) === false) {
                    isMore = true
                }
            }
            return isMore
        }
        , setCategoryListAdmin () {
            let category = this.basic.data.category_display.value
            let list = []
            for (let k in category) {
                let data = category[k]
                if ("ppc_id" in data && data.ppc_menu_display == 'Y') {
                    list.push(data)
                }
            }
            this.categoryList = list
        }
        , categoryMoveUrl (url) {
            if (this.getAdminEditMode()) { 
                return "javascript:void(0);"
            }
            return url
        }
    }
    , updated () {
		if (this.categoryList.length > 0) {
            if (templateType == 'shop') {
                this.categorySwiperShop()
            } else {
                this.categorySwiper()
            }
        }
        if (this.getAdminEditMode() && this.isSetBasicData('category_display')) {
            if (this.checkCategoryDisplayChange()) {
                this.setCategoryListAdmin()
            }
        }
    }
})
